<form (keydown.enter)="$event.preventDefault()" [formGroup]="inputForm"
      class="flex flex-row full-grow-no-shrink-no-basis">
  <mat-form-field appearance="outline" class="flex-1-1-100">
    <mat-label>Select Case</mat-label>
    <!--<input formControlName="entityType" matInput placeholder="" required>-->
    <mat-select formControlName="value" (selectionChange)="onSelectionChange($event)">
      <mat-option *ngFor="let data of (dropdownData$|async)" [value]="data">
        {{data.caseId}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</form>
